import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const DeleteDocumentIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      <path
        d="M10.3477 6.2461C10.3477 6.29994 10.3915 6.34375 10.4453 6.34375H12.678C12.6244 6.24481 12.5555 6.15393 12.4726 6.07555L10.5894 4.29387C10.5163 4.22473 10.4349 4.16705 10.3477 4.12151L10.3477 6.2461Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.76172 6.24609C9.76172 6.62303 10.0684 6.92969 10.4453 6.92969H12.8086V10.0352C12.6776 10.013 12.5434 10 12.4062 10C11.0794 10 10 11.0794 10 12.4062C10.0001 13.0178 10.2312 13.5751 10.6084 14H6.26562C5.6733 14 5.19141 13.5181 5.19141 12.9258V5.07422C5.19141 4.48189 5.6733 4 6.26562 4H9.76172V6.24609ZM6.79297 11.0312C6.63117 11.0312 6.5 11.1624 6.5 11.3242C6.5 11.486 6.63117 11.6172 6.79297 11.6172H8.21289C8.37469 11.6172 8.50586 11.486 8.50586 11.3242C8.50586 11.1624 8.37469 11.0312 8.21289 11.0312H6.79297ZM6.79297 9.46875C6.63117 9.46875 6.5 9.59992 6.5 9.76172C6.5 9.92352 6.63117 10.0547 6.79297 10.0547H11.0898C11.2516 10.0547 11.3828 9.92352 11.3828 9.76172C11.3828 9.59992 11.2516 9.46875 11.0898 9.46875H6.79297ZM6.79297 7.90625C6.63117 7.90625 6.5 8.03742 6.5 8.19922C6.5 8.36102 6.63117 8.49219 6.79297 8.49219H11.0898C11.2516 8.49219 11.3828 8.36102 11.3828 8.19922C11.3828 8.03742 11.2516 7.90625 11.0898 7.90625H6.79297Z"
        fill="currentColor"
      />
      <g clipPath="url(#clip0_14483_173223)">
        <path
          d="M12.4062 10.4059C11.3034 10.4059 10.4062 11.303 10.4062 12.4059C10.4062 13.5087 11.3034 14.4059 12.4062 14.4059C13.5091 14.4059 14.4062 13.5087 14.4062 12.4059C14.4062 11.303 13.5091 10.4059 12.4062 10.4059Z"
          fill="#E13F41"
        />
        <path
          d="M13.1427 12.9069C13.2079 12.9721 13.2079 13.0774 13.1427 13.1426C13.1102 13.1751 13.0675 13.1914 13.0248 13.1914C12.9822 13.1914 12.9395 13.1751 12.907 13.1426L12.4062 12.6417L11.9054 13.1426C11.8729 13.1751 11.8302 13.1914 11.7875 13.1914C11.7449 13.1914 11.7022 13.1751 11.6697 13.1426C11.6045 13.0774 11.6045 12.9721 11.6697 12.9069L12.1705 12.4061L11.6697 11.9053C11.6045 11.8401 11.6045 11.7347 11.6697 11.6696C11.7349 11.6044 11.8402 11.6044 11.9054 11.6696L12.4062 12.1704L12.907 11.6696C12.9722 11.6044 13.0775 11.6044 13.1427 11.6696C13.2079 11.7347 13.2079 11.8401 13.1427 11.9053L12.6419 12.4061L13.1427 12.9069Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14483_173223">
          <rect
            width="4"
            height="4"
            fill="white"
            transform="translate(10.4062 10.4062)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DeleteDocumentIcon;
